import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import InProgressReviewStore from 'stores/coaching/InProgressReviewStore';
import Button from '@material-ui/core/Button';
import {Link} from 'react-router';
import AuthStore from 'stores/AuthStore';
import {reviewPath} from 'components/dashboard/reviewPath';

@connectToStores
export default class AgendaStartOrContinueMeetingButton extends React.PureComponent {
  static getStores() {
    return [AuthStore, InProgressReviewStore];
  }

  static getPropsFromStores({review}) {
    if (!review) {
      return {};
    }
    const {inProgressReviews} = InProgressReviewStore.getState();
    return {
      sessionUser: AuthStore.getState().user,
      inProgress: !!inProgressReviews.get(review.id + ''), // keys are strings.
    };
  }

  render() {
    const {inProgress, review, sessionUser} = this.props;
    const buttonLabelVerb = inProgress ? 'Continue' : 'Start';
    const buttonProps = inProgress ? {secondary: true} : {primary: true};
    return (
      <Button
        variant="contained"
        color="primary"
        fullWidth
        component={Link}
        to={{
          pathname: reviewPath(sessionUser),
          query: {
            planId: review.planId,
            repId: review.coachingPlan.recipient.id,
            reviewId: review.id,
            autoStartReview: true,
          },
        }}
        {...buttonProps}>
        {`${buttonLabelVerb} Meeting`}
      </Button>
    );
  }
}
